import { render, staticRenderFns } from "./HistoryBalanceTable.vue?vue&type=template&id=223ca95e&scoped=true"
import script from "./HistoryBalanceTable.vue?vue&type=script&lang=js"
export * from "./HistoryBalanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ca95e",
  null
  
)

export default component.exports